import { render } from "preact";
import { lazy, Suspense } from "preact/compat";
import { CallerPage } from "./caller/CallerPage";

// /q/<code> is the scanned page; the connectivity check stays as a development tool.
const ConnectivityCheck = lazy(() => import("./p0/ConnectivityCheck").then((m) => ({ default: m.ConnectivityCheck })));

const scanned = /^\/q\/([A-Za-z0-9]{8})\/?$/.exec(location.pathname);
render(
  scanned ? (
    <CallerPage code={scanned[1]!} />
  ) : (
    <Suspense fallback={null}>
      <ConnectivityCheck />
    </Suspense>
  ),
  document.getElementById("app")!,
);
